module.exports = __webpack_public_path__ + "img/sicilia_2880x1800.2698bbd8.jpg";